export default __webpack_public_path__ + "static/media/img2pro8.9fc2503e.jpeg";